import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import * as currencies from "@dinero.js/currencies";
import { dinero, toDecimal } from "dinero.js";
import { Subscription } from "rxjs";

@Pipe({ name: "minorUnitCurrency", standalone: true, pure: false })
export class MinorUnitCurrencyPipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;
  private currentLocale: string;

  constructor(
    private translateService: TranslateService,
    private cd: ChangeDetectorRef
  ) {
    this.currentLocale = this.getLocale(this.translateService.currentLang);

    this.subscription = this.translateService.onLangChange.subscribe(({ lang }) => {
      this.currentLocale = this.getLocale(lang);
      this.cd.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getLocale(lang: string): string {
    const map: Record<string, string> = { fr: "fr-FR", en: "en-US" };
    return map[lang] ?? "en-US";
  }

  transform(amount: number | null | undefined, currencyCode: string): string {
    if (amount == null) {
      return "";
    }

    const currency = (currencies as Record<string, any>)[currencyCode];

    if (!currency) {
      return String(amount);
    }

    const value = toDecimal(
      dinero({
        amount,
        currency,
      })
    );

    return new Intl.NumberFormat(this.currentLocale, {
      style: "currency",
      currency: currencyCode,
    }).format(Number(value));
  }
}
